export const toast = {
    /**
     * Show a toast notification.
     * @param {boolean} type - The type of the notification. True for success, false for error.
     * @param {string} message - The message to be displayed in the notification.
     * @param {string} direction - The direction from which the notification should slide in. Default is 'right'.
     */
    showNotification(type, message, direction = 'right') {
        // If a toast already exists, remove it
        var existingToast = document.getElementById('toast');
        if (existingToast) {
            document.body.removeChild(existingToast);
        }

        // Create a new div element for the toast notification
        const toastDiv = document.createElement("div");
        toastDiv.id = "toast";
        toastDiv.className = "toast";
        toastDiv.textContent = message;

        // Add a class based on the type of notification
        toastDiv.classList.add(type ? 'success' : 'error');
        toastDiv.style.zIndex = '9999';

        // Apply styles based on the direction
        if (direction === 'top') {
            toastDiv.style.top = '0';
            toastDiv.style.right = '50%';
            toastDiv.style.animation = "slide-down 0.5s forwards, slide-up 0.5s 4s forwards";
        } else if (direction === 'right') {
            toastDiv.style.right = '0';
            toastDiv.style.animation = "slide-in 0.5s forwards, slide-out 0.5s 4s forwards";
        }

        // Append the toast notification to the body
        document.body.appendChild(toastDiv);

        // After 10 seconds, remove the toast notification from the DOM
        // setTimeout(() => {
        //     existingToast = document.getElementById('toast');
        //     if (existingToast) {
        //         document.body.removeChild(existingToast);
        //     }
        // }, 10000);
    }
};